import React from "react";
import "./Include_Services.css";
import { ServiceId } from "../../../../utils/apis/service/Service";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { IDS } from "../../../../utils/common";
import { Context } from "../../../../utils/context";

const Include_Services = () => {
  const servicesData = [
    {
      title: "Site Survey & Feasibility Analysis",
      description:
        "A detailed rooftop inspection to assess shadow-free area, structure strength, and optimal system size.",
      icon: "/assets/images/services/service-inner/logo-1.png",
    },
    {
      title: "Customized System Design",
      description:
        "Tailor-made solar plant design to ensure maximum power generation and efficiency for your household.",
      icon: "/assets/images/services/service-inner/logo-2.png",
    },
    {
      title: "Installation & Commissioning",
      description:
        "Safe and professional installation using high-quality solar panels, inverters, & mounting structures, followed by testing and commissioning.",
      icon: "/assets/images/services/service-inner/logo-3.png",
    },
    {
      title: "Net-Metering Support",
      description:
        "Complete coordination with the local DISCOM for net-meter installation, enabling you to export surplus power and earn credits.",
      icon: "/assets/images/services/service-inner/logo-4.png",
    },
    {
      title: "Subsidy Assistance (PM Surya Ghar)",
      description:
        "End-to-end support for government subsidy—from application to approval and subsidy credit into your bank account.",
      icon: "/assets/images/services/service-inner/logo-5.png",
    },
    {
      title: "Operation & Maintenance (Optional)",
      description:
        "Regular cleaning, preventive maintenance, system monitoring, and performance support to keep your system running efficiently.",
      icon: "/assets/images/services/service-inner/logo-6.png",
    },
  ];

  const { id } = useParams();

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [service, setService] = useState({});
  const [serviceinclude, setServiceInclude] = useState([]);

  const getServiceInclude = async () => {
    const res = await ServiceId(id);

    if (res?.success) {
      setService(res?.data || {});
      setServiceInclude(res?.data?.servinclude_id || []);
    }
  };

  useEffect(() => {
    if (id) {
      getServiceInclude();
    }
  }, [id]);

  return (
    <section className="Include_Services">
      <div className="container">
        <div className="Include_Services_header_holder">
          <p className="Include_Services_header">
            {htmlToReactParser.parse(service.name)} Services Include
          </p>
        </div>

        <div className="row">
          {serviceinclude.map((item) => (
            <div className="col-lg-6 mt-4" key={item.id}>
              <div className="service_card">
                <div className="service_icon_holder">
                  <img
                    src={IDS?.IMG_URL + item?.image}
                    alt={item.name}
                    className="service_icon"
                  />
                </div>

                <div className="service_content">
                  <h5 className="service_title">{item.name}</h5>

                  <p className="service_text">
                    {htmlToReactParser.parse(item?.description)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Include_Services;
